@if (canViewIdentityProviders) {
  <div class="tab-content" [class.loading]="!isContentReady">
    @if (!isContentReady) {
      <svg lucideLoaderCircle class="tab-loading-spinner lucide-spin"></svg>
    }
    @if (isContentReady) {
      <p class="double-margin-bottom">
        View and manage any SAML Identity Providers you have connected to your Arpio account.
      </p>
      @if (accountService.listIdentityProviders(false).length > 0) {
        <table class="arpio-table">
          <tr>
            <th class="nowrap strong-text type-column">Type</th>
            <th class="nowrap strong-text name-column">Name</th>
            @if (canManageIdentityProviders) {
              <th class="nowrap strong-text actions-column">Actions</th>
            }
          </tr>
          @for (idp of accountService.listIdentityProviders(false); track idp) {
            <tr>
              <td class="nowrap">{{ typeDisplay(idp.type) }}</td>
              <td class="nowrap">{{ idp.name }}</td>
              @if (canManageIdentityProviders) {
                <td class="actions-column">
                  <ng-container>
                    <button
                      type="button"
                      class="icon"
                      aria-label="Update"
                      pTooltip="Update"
                      tooltipPosition="top"
                      (click)="openEditIdpDialog(idp)"
                    >
                      <svg lucideSquarePen></svg>
                    </button>
                    <button
                      type="button"
                      class="icon"
                      aria-label="Delete"
                      pTooltip="Delete"
                      tooltipPosition="top"
                      (click)="openDeleteConfirmModal(idp)"
                    >
                      <svg lucideTrash2 class="margin-left"></svg>
                    </button>
                    @if (idp.type === 'msEntra' && !idp.config.consented) {
                      <button
                        type="button"
                        class="icon"
                        aria-label="Grant Consent"
                        pTooltip="Grant Consent"
                        tooltipPosition="top"
                        (click)="startMsEntraIdpAppConsentFlow(idp)"
                      >
                        <svg lucideShieldCheck class="margin-left"></svg>
                      </button>
                    }
                  </ng-container>
                </td>
              }
            </tr>
          }
        </table>
      } @else {
        <div>No Identity Providers have been set up yet.</div>
      }
      <ng-container>
        @if (accountService.ssoEnabled() && canManageIdentityProviders) {
          <button
            type="button"
            id="add-saml-idp-button"
            class="margin-top arpio-button small-button"
            (click)="openAddSamlIdpDialog()"
          >
            Add SAML Identity Provider
          </button>
        }
        @if (accountService.azureEnabled() && canManageIdentityProviders) {
          <button
            type="button"
            id="add-entra-dir-button"
            class="margin-top margin-left arpio-button small-button"
            (click)="openAddMsEntraIdpDialog()"
          >
            Add Microsoft Entra Directory
          </button>
        }
      </ng-container>
      <!-- Unified IDP Modal -->
      <app-idp-modal
        #idpModal
        [accountId]="accountService.accountId"
        (save)="onIdpModalSave($event)"
        (cancel)="onIdpModalCancel()"
      ></app-idp-modal>
      <!-- Delete IDP Modal -->
      <modal-dialog #deleteIdpDialog [dialogTemplate]="confirmDeleteDialog"></modal-dialog>
      <ng-template #confirmDeleteDialog>
        <confirm-action-dialog
          name="&quot;{{ toDelete.name }}&quot;"
          dialogId="delete-identity-provider-confirm"
          (onCancel)="dismissDeleteConfirmModal()"
          (onAction)="deleteIdp(toDelete.identityProviderId)"
        >
          <div class="error margin-top">
            Note: Deleting this identity provider will revoke access for all users who authenticate with it.
          </div>
        </confirm-action-dialog>
      </ng-template>
    }
  </div>
}
